import { CartPayload } from '@customTypes/cart-payload';
import ProductData from '@customTypes/product';

import { parseMilitaryTime } from '@helpers/date';

import { sendToGTM } from './GTM';

/**
 * Track guest quantity selected for a Time Slotted Product after clicking in Add to Cart
 * @param timeSlottedProduct ProductData
 * @param cart CartPayload
 */
const quantitySelected = (timeSlottedProduct: ProductData, cart: CartPayload) => {
  sendToGTM({
    event: 'time_slotted_product_quantity_selected',
    time_slotted_product: {
      product_type: timeSlottedProduct.product_type,
      product_name: timeSlottedProduct.name,
      adults_count: cart.items[0].no_of_adults || 0,
      children_count: cart.items[0].no_of_childs || 0,
    },
  });
};

/**
 * Track when a user clicks on Select button at DLP for any Time Slotted Product.
 * @param timeSlottedProduct ProductData
 */
const timeSlotProductSelected = (timeSlottedProduct: ProductData) => {
  sendToGTM({
    event: 'time_slotted_product_selected',
    time_slotted_product: {
      product_type: timeSlottedProduct.product_type,
      product_name: timeSlottedProduct.name,
    },
  });
};

/**
 * Track when a user select any time from a Time Slotted Product
 * @param timeSlottedProduct ProductData
 */
const timeSelected = (timeSlottedProduct: ProductData) => {
  sendToGTM({
    event: 'time_slotted_product_time_selected',
    time_slotted_product: {
      product_id: timeSlottedProduct.product_id,
      product_name: timeSlottedProduct.name,
      start_time: parseMilitaryTime(timeSlottedProduct.start_time, false),
      end_time: parseMilitaryTime(timeSlottedProduct.end_time, false),
    },
  });
};

export { quantitySelected, timeSlotProductSelected, timeSelected };
